import { render } from "./Classes.vue?vue&type=template&id=2924c3df&scoped=true&ts=true"
import script from "./Classes.vue?vue&type=script&lang=ts"
export * from "./Classes.vue?vue&type=script&lang=ts"

import "./Classes.vue?vue&type=style&index=0&id=2924c3df&scoped=true&lang=css"

import exportComponent from "/home/runner/work/studiostvapp/studiostvapp/PlatformStudiosApp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2924c3df"]])

export default __exports__